import CodeCreate from '../../code/CodeCreate'
import CodeUpdate from '../../code/CodeUpdate'
import CodeInfo from '../../code/CodeInfo'
import { AUTH_GROUP } from '../../constants/constants'
import UserServices from '@/services/UserServicies'
import CustomerServices from "@/services/CustomerServices";
import CodeList from '../../code/CodeList'
import FileServices from "@/services/FileServices";
import {MARKET_SERVICE_CODE} from "@/constants/constants";

const types = {
  CREATE_USER: '@user/CREATE_USER',
  UPDATE_USER: '@user/UPDATE_USER',
  GET_USER_INFO: '@user/GET_USER_INFO',
  GET_USER_DETAIL: '@user/GET_USER_DETAIL',
  CHANGE_USER_STATUS: '@user/CHANGE_USER_STATUS',
  GET_CONTRACT_LIST: '@customer/GET_CONTRACT_LIST',
  GET_USER_LIST: '@user/GET_USER_LIST',
  GET_IDP_USER_LIST: '@user/GET_IDP_USER_LIST',
  GET_IDP_USER_INFO: '@user/GET_IDP_USER_INFO',
}

export {
  types as userTypes
}
export default {
  namespaced: true,
  state: {
    codeUserCreate: CodeCreate.READY,
    codeUserUpdate: CodeUpdate.READY,
    codeChangeUserStatus: CodeUpdate.READY,
    codeUserDetail: CodeInfo.READY,
    codeUserInfo: CodeInfo.READY,
    codeUserList: CodeInfo.READY,
    codeIDPUserList: CodeInfo.READY,
    userException: {},
    userErrorMessage: '',
    userInfo: {},
    userDetail: {},
    changeUserStatus: '',
    contractList: '',
    userList: {},
    IDPUserList: {},
    IDPUserInfo: {},
  },

  getters: {
    codeUserCreate: state => state.codeUserCreate,
    codeUserUpdate: state => state.codeUserUpdate,
    codeChangeUserStatus: state => state.codeChangeUserStatus,
    codeUserDetail: state => state.codeUserDetail,
    CodeUserInfo: state => state.CodeUserInfo,
    codeUserList: state => state.codeUserList,
    codeIDPUserList: state => state.codeIDPUserList,
    changeUserStatus: state => state.changeUserStatus,
    userException: state => state.userException,
    userErrorMessage: state => state.userErrorMessage,
    userInfo: state => state.userInfo,
    userDetail: state => state.userDetail,
    contractList: state => state.contractList,
    userList: state => state.userList,
    IDPUserList: state => state.IDPUserList,
    IDPUserInfo: state => state.IDPUserInfo
  },

  mutations: {
    [types.CREATE_USER] (state, payload) {
      state.codeUserCreate = payload.codeUserCreate
      state.userException = payload.userException || {}
      state.userErrorMessage = payload.userErrorMessage || ''
    },
    [types.GET_USER_INFO] (state, payload) {
      state.CodeUserInfo = payload.CodeUserInfo
      state.userInfo = payload.userInfo
    },
    [types.GET_USER_DETAIL] (state, payload) {
      state.codeUserDetail = payload.codeUserDetail
      state.userDetail = payload.userDetail
      //  token에서 이름과 성 정보를 읽어와서 추가 세팅한다(임시 방편)
      if (window && window.keycloak && window.keycloak.token) {
        const token = window.keycloak.token

        //  jwt token parsing
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))

        const tokenObj = JSON.parse(jsonPayload)
        state.userDetail.familyName = tokenObj.family_name || ''
        state.userDetail.givenName = tokenObj.given_name || ''
        state.userDetail.locale = tokenObj.locale || 'ko'
      }
    },

    [types.UPDATE_USER] (state, payload) {
      state.codeUserUpdate = payload.codeUserUpdate
      state.userException = payload.userException || {}
      state.userErrorMessage = payload.userErrorMessage || ''
    },
    [types.CHANGE_USER_STATUS] (state, payload) {
      state.codeChangeUserStatus = payload.codeChangeUserStatus
      state.userException = payload.userException || {}
      state.userErrorMessage = payload.userErrorMessage || ''
      state.changeUserStatus = payload.changeUserStatus || ''
    },
    
    [types.GET_CONTRACT_LIST] (state, payload) {
      state.contractList = payload.contractList
    },
    [types.GET_USER_LIST] (state, payload) {
      state.userList = payload.userList
      state.codeUserList = payload.codeUserList
    },
    [types.GET_IDP_USER_LIST] (state, payload) {
      state.IDPUserList = payload.IDPUserList
      state.codeIDPUserList = payload.codeIDPUserList
    },

    [types.GET_IDP_USER_INFO] (state, payload) {
      state.IDPUserInfo = payload.IDPUserInfo
    },
  },
  actions: {
    
    async getUserInfo ({commit}) {
      try {
        const response = await UserServices.getUsersUserInfo()
        const userinfo  = response.data.resultData;

        
        commit(types.GET_USER_INFO, {
          userInfo: userinfo,
          codeUserInfo: CodeInfo.SUCCESS
        })
        return response.data.code
      } catch (e) {
        commit(types.GET_USER_INFO, {
          userInfo: {},
          codeUserInfo: CodeInfo.EXCEPTION
        })
      }
    },
    async getUserDetail ({commit}, payload) {
      const { userId, reload = true} = payload

      if (reload) {
        commit(types.GET_USER_DETAIL, {
          userDetail: {},
          codeUserDetail: CodeInfo.READY
        })
      }
      try {
        const response = await UserServices.getUsersWithUserId(userId)

        commit(types.GET_USER_DETAIL, {
          userDetail: response.data.resultData,
          codeUserDetail: CodeInfo.SUCCESS
        })
      } catch (e) {
        commit(types.GET_USER_DETAIL, {
          userDetail: {},
          codeUserDetail: CodeInfo.EXCEPTION
        })
      }
    },

    async getIsUserExists ({commit}, payload) {
      const { userId} = payload
      try {
        const response = await UserServices.getUsersWithUserId(userId)
        return response.data.code == 0;
      } catch (e) {
        return false;
      }
    },
   
    
    
    async createUser ({commit}, userInfo) {
      commit(types.CREATE_USER, {
        codeUserCreate: CodeCreate.READY
      })
      
      try {
        const response = await UserServices.postUsers({
          companyCode: userInfo.companyCode,
          customerCode: userInfo.customerCode,
          customerDeptCode: userInfo.deptCode,
          customerDeptName: userInfo.deptName,
          customerName: userInfo.customerName,
          customerRegistorNo: userInfo.customerRegisNo,
          auth: userInfo.auth,
          leader: userInfo.auth === AUTH_GROUP.BespinMiddleManager ? userInfo.leader : undefined,
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          userName: userInfo.userName,
          groupId: userInfo.groupId,
          userEmail: userInfo.userEmail,
          userTelNo: userInfo.userTelNo,
          userTelNoCtrCd: userInfo.userTelNoCtrCd,
          duty: userInfo.duty,
          idpStatus: userInfo.idpStatus
        })
        if (response.data.resultData && response.data.resultData.result === 'Y') {
          commit(types.CREATE_USER, {
            codeUserCreate: CodeCreate.SUCCESS
          })
        } else {
          commit(types.CREATE_USER, {
            codeUserCreate: CodeCreate.ERROR,
            userErrorMessage: response.data.resultData ? response.data.resultData.result : response.data.codeName
          })
        }
      } catch (e) {
        
        commit(types.CREATE_USER, {
          codeUserCreate: CodeCreate.EXCEPTION,
          userException: e
        })
      }
      return null
    },
    async updateUser ({ getters, commit, dispatch }, payload) {
      const {userId, userEmail, auth, leader} = payload
      try {
        commit(types.UPDATE_USER, {
          codeUserUpdate: CodeUpdate.READY
        })

        const { userInfo } = getters
        const response = await UserServices.putUsers({userId, userEmail, auth, leader})

        if (response.data.resultData.result === 'Y') {
          if (userInfo.userId === userId) {
            dispatch('getUserInfo')
          }
          commit(types.UPDATE_USER, {
            codeUserUpdate: CodeUpdate.SUCCESS
          })

          dispatch('getUserDetail', {
            userId,
            reload: false
          })
        } else {
          commit(types.UPDATE_USER, {
            codeUserUpdate: CodeUpdate.ERROR,
            userErrorMessage: response.data.resultData.result
          })
        }
      } catch (e) {
        
        commit(types.UPDATE_USER, {
          codeUserUpdate: CodeUpdate.EXCEPTION,
          userException: e
        })
      }
    },
    async updateUserStatus({ commit, dispatch }, { userId, useYn }) {
      try {
        commit(types.CHANGE_USER_STATUS, {
          codeChangeUserStatus: CodeUpdate.READY,
          changeUserStatus: useYn
        })

        const response = await UserServices.putUsersStatusWithUserIdAndUseYn(
          userId,
          useYn
        )

        if (response.data.resultData.result === 'Y') {
          commit(types.CHANGE_USER_STATUS, {
            codeChangeUserStatus: CodeUpdate.SUCCESS,
            changeUserStatus: useYn
          })

          if (useYn !== 'D') {
            dispatch('getUserDetail', {
              userId,
              reload: false
            })
          }
        } else {
          commit(types.CHANGE_USER_STATUS, {
            codeChangeUserStatus: CodeUpdate.ERROR,
            userErrorMessage: response.data.resultData.result,
            changeUserStatus: useYn
          })
        }

      } catch (e) {
        commit(types.CHANGE_USER_STATUS, {
          codeChangeUserStatus: CodeUpdate.EXCEPTION,
          changeUserStatus: useYn,
          userException: e
        })
      }
    },
    
    async getUserList({commit}, payload) {

      commit(types.GET_USER_LIST, {
        codeUserList: CodeList.READY,
        userList: {}
      })
      try {
        const response = await UserServices.getUesrList(payload)

        commit(types.GET_USER_LIST, {
          codeUserList: CodeList.SUCCESS,
          userList: response.data.resultData
        })
      } catch (e) {
        commit(types.GET_USER_LIST, {
          codeUserList: CodeList.EXCEPTION,
          userList: {}
        })
      }
      return null
    },

    async getIDPUserList({commit}, payload) {
      commit(types.GET_IDP_USER_LIST, {
        codeIDPUserList: CodeList.READY,
        IDPUserList: {}
      })
      try {
        const response = await UserServices.getIDPUesrList(payload)

        commit(types.GET_IDP_USER_LIST, {
          codeIDPUserList: CodeList.SUCCESS,
          IDPUserList: response.data.resultData
        })
      } catch (e) {
        commit(types.GET_IDP_USER_LIST, {
          codeIDPUserList: CodeList.EXCEPTION,
          IDPUserList: {}
        })
      }
      return null
    },

    async getCSVDownLoad({commit}, payload){
      await FileServices.getCSVFile(payload)
    },

    async getCustomerContract ({commit},payload) {

      const { customerCode, customerDeptCode,companyCode ,userEmail} = payload

      const response = await CustomerServices.getCustomerContractList({
        customerCode, customerDeptCode,companyCode,userEmail
      })

      commit(types.GET_CONTRACT_LIST, { contractList: response.data.resultData});

      return response.data.resultData;
    },

    async deleteCustomerContractList ({ commit },  payload) {
      const { contractCode, customerCode, customerDeptCode, companyCode,userEmail } = payload
      const response = await CustomerServices.deleteCustomerContractList(contractCode, customerCode, customerDeptCode, companyCode,userEmail)
      return response.data.resultData
    },

    async getUserGroup ({commit},payload) {
      const { serviceCode, siteCode ,userEmail} = payload
      const response = await UserServices.getUserGroup({
        serviceCode, siteCode,userEmail
      })

      return response.data.resultData;
    },
    async getInnerUserInfo ({commit},payload) {
      const {userEmail} = payload
      const response = await UserServices.getInnerUserInfo({userEmail})
      return response.data.resultData;
    },

    async updateUserCustomer ({commit},payload) {
      const {userEmail, customerCode, customerDeptCode} = payload
      const response = await UserServices.updateUserCustomer({userEmail, customerCode, customerDeptCode})
      return response.data.resultData;
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js